import { useState } from "react";

import ExpertDetailModal from "@/components/v2/ExpertDetailModal";

const EXPERTS = [
    {
        key: "archan",
        name: "Mr. Archan Oke",
        role: "Operations \u2022 Engineering \u2022 Leadership",
        img: "/img/experts/archan_oke.jpg",
        alt: "Mr. Archan Oke, C-ORE Expert \u2014 Operations, Engineering, Leadership",
        bio: [
            "30+ years of experience across operations, engineering and organizational leadership, including experience in the USA.",
            "He has headed operations across multiple multinational organizations, leading complex operational functions, engineering teams and large-scale execution environments.",
        ],
        expertise: [
            "Operations",
            "Engineering Management",
            "Team Leadership",
            "Process Excellence",
            "Organizational Execution",
        ],
    },
    {
        key: "mallika",
        name: "Ms. Mallika Shetty",
        role: "Fundraising \u2022 M&A \u2022 Strategic Finance",
        img: "/img/experts/mallika_shetty.jpg",
        alt: "Ms. Mallika Shetty, C-ORE Expert \u2014 Fundraising, M&A, Strategic Finance",
        bio: [
            "IIM Nagpur alumna with extensive expertise in fundraising, mergers & acquisitions and strategic financial growth.",
            "Her experience includes helping businesses understand fundraising requirements, evaluate strategic opportunities and navigate important financial and corporate-growth decisions.",
        ],
        expertise: [
            "Fundraising",
            "M&A",
            "Strategic Finance",
            "Investment Readiness",
            "Corporate Growth",
        ],
    },
    {
        key: "swapnil",
        name: "Mr. Swapnil C.",
        role: "D2C \u2022 Sales Operations \u2022 Technology",
        img: "/img/experts/swapnil_c.jpg",
        alt: "Mr. Swapnil C., C-ORE Expert \u2014 D2C, Sales Operations, Technology",
        bio: [
            "Extensive experience in D2C operations, sales operations, channel expansion and sales technology.",
            "His experience includes scaling businesses from early stages toward broader channel operations while building the internal processes and technology systems required to support growth.",
        ],
        expertise: [
            "D2C Operations",
            "Sales Operations",
            "Channel Expansion",
            "Sales Technology",
            "Operational Scaling",
        ],
    },
    {
        key: "aditya",
        name: "Mr. Aditya More",
        role: "Product \u2022 Innovation \u2022 Scaling",
        img: "/img/experts/aditya_more.jpg",
        alt: "Mr. Aditya More, C-ORE Expert \u2014 Product, Innovation, Scaling",
        bio: [
            "Engineer and IIM Kozhikode alumnus. Founder & CEO of MecTURING, a consumer robotics brand.",
            "His experience spans product design, engineering, innovation, manufacturing and business scaling.",
            "He has been involved in developing and launching 10+ products, including patented innovation as an inventor. His experience covers the journey from identifying an opportunity and designing a product through development, manufacturing, market launch and scaling.",
        ],
        expertise: [
            "Product Strategy",
            "Product Innovation",
            "Technology",
            "Manufacturing",
            "Business Scaling",
            "Go-to-Market Execution",
        ],
    },
];

export default function ExpertStrip() {
    const [openKey, setOpenKey] = useState(null);
    const activeExpert = EXPERTS.find((e) => e.key === openKey) || null;

    return (
        <div className="expert-strip reveal" data-testid="v2-expert-strip">
            <div
                className="expert-strip__row"
                role="list"
                aria-label="Preview of the C-ORE Expert network"
                data-testid="v2-expert-strip-row"
            >
                {EXPERTS.map((e) => (
                    <button
                        type="button"
                        className="expert-strip__item expert-strip__item--btn"
                        role="listitem"
                        key={e.key}
                        onClick={() => setOpenKey(e.key)}
                        aria-haspopup="dialog"
                        aria-label={`View expert profile: ${e.name}, ${e.role}`}
                        data-testid={`v2-expert-${e.key}`}
                    >
                        <img
                            className="expert-strip__photo"
                            src={e.img}
                            alt={e.alt}
                            loading="lazy"
                        />
                        <div className="expert-strip__name">{e.name}</div>
                        <div className="expert-strip__role">{e.role}</div>
                    </button>
                ))}
                <div
                    className="expert-strip__item"
                    role="listitem"
                    data-testid="v2-expert-more"
                >
                    <div className="expert-strip__badge" aria-hidden="true">
                        50+
                    </div>
                    <div className="expert-strip__name">50+ Experts</div>
                    <div className="expert-strip__role">
                        across different domains
                    </div>
                </div>
            </div>

            <ExpertDetailModal
                expert={activeExpert}
                onClose={() => setOpenKey(null)}
            />
        </div>
    );
}
